'use strict';

var jsUtils = require('@swiggy-private/js-utils');
var components_FoodItem_helpers_index = require('./index-2bhV6eMA.js');
var components_Customise_constants_index = require('./components/Customise/constants/index.js');

const getName = (item) => item === null || item === void 0 ? void 0 : item.name;
const getPrice = (item) => {
    if (!jsUtils.isEmpty(item === null || item === void 0 ? void 0 : item.defaultPrice)) {
        return item && item.defaultPrice ? components_FoodItem_helpers_index.possiblePrecision(item.defaultPrice / 100) : 0;
    }
    else if (!jsUtils.isEmpty(item === null || item === void 0 ? void 0 : item.price)) {
        return item && item.price ? components_FoodItem_helpers_index.possiblePrecision(item.price / 100) : 0;
    }
    return 0;
};
const getFinalPrice = (item) => !jsUtils.isEmpty(item === null || item === void 0 ? void 0 : item.final_price) && (item === null || item === void 0 ? void 0 : item.final_price)
    ? components_FoodItem_helpers_index.possiblePrecision(item.final_price / 100)
    : getPrice(item);
const CUSTOMIZE_VERSIONS = {
    V1: 1,
    V2: 2,
};
const PRICE_RANGE = `\u20B9{0} - \u20B9{1}`;
const getVersion = (item) => {
    const variantsKey = "variantsV2";
    return jsUtils.isEmpty(jsUtils.getNestedValue(item, variantsKey + ".variantGroups") ||
        jsUtils.getNestedValue(item, variantsKey + ".variant_groups"))
        ? CUSTOMIZE_VERSIONS.V1
        : CUSTOMIZE_VERSIONS.V2;
};
const getPricingModels = (item) => {
    const version = getVersion(item);
    const variantsKey = version == CUSTOMIZE_VERSIONS.V2 ? "variantsV2" : "variants_new";
    return (jsUtils.getNestedValue(item, variantsKey + ".pricingModels", []) ||
        jsUtils.getNestedValue(item, variantsKey + ".pricing_models", []));
};
const getPriceRange = (item) => {
    var _a, _b;
    const pricingModels = getPricingModels(item);
    if (!jsUtils.isEmpty(pricingModels)) {
        const priceRange = pricingModels.reduce((acc, elem) => {
            acc.max = Math.max(elem.price, acc.max);
            acc.min = Math.min(elem.price, acc.min);
            return acc;
        }, {
            max: (_a = pricingModels[0]) === null || _a === void 0 ? void 0 : _a.price,
            min: (_b = pricingModels[0]) === null || _b === void 0 ? void 0 : _b.price,
        });
        if (priceRange.max === priceRange.min) {
            return jsUtils.format(PRICE_RANGE, Math.round(priceRange.max / 100));
        }
        else {
            return jsUtils.format(PRICE_RANGE, Math.round(priceRange.min / 100), Math.round(priceRange.max / 100));
        }
    }
    return "";
};
const getVariantInStock = (variant) => variant.inStock === 1;
const getAddons = (item) => (item === null || item === void 0 ? void 0 : item.addons) || [];
const getChoices = (addonGroup) => (addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.choices) || [];
const getAddonId = (addon) => addon.id;
const getAddonName = (addon) => addon.name;
const getSelectedAddons = (item, selectedAddons) => {
    const addons = getAddons(item);
    const selectedAddonList = [];
    addons.forEach((addonGroup, addonIndex) => {
        const choices = getChoices(addonGroup);
        if (!jsUtils.isEmpty(selectedAddons[addonIndex]) && !jsUtils.isEmpty(choices)) {
            choices.forEach((choice, choiceIndex) => {
                if (!jsUtils.isEmpty(selectedAddons[addonIndex][choiceIndex])) {
                    selectedAddonList.push({
                        choice_id: getAddonId(choice),
                        choiceId: getAddonId(choice),
                        name: getAddonName(choice),
                    });
                }
            });
        }
    });
    return selectedAddonList;
};
const getVariants = (item) => {
    const version = getVersion(item);
    const variantsKey = version == CUSTOMIZE_VERSIONS.V2 ? "variantsV2" : "variants_new";
    return (jsUtils.getNestedValue(item, variantsKey + ".variant_groups") ||
        jsUtils.getNestedValue(item, variantsKey + ".variantGroups", []));
};
const getSelectedVariants = (item, selectedVariants) => {
    const variantGroups = getVariants(item);
    const selectedVariantList = [];
    if (!jsUtils.isEmpty(variantGroups)) {
        variantGroups.forEach((group, index) => {
            if (!jsUtils.isEmpty(selectedVariants[index])) {
                selectedVariantList.push({
                    variation_id: selectedVariants[index].id,
                    variationId: selectedVariants[index].id,
                    group_id: group === null || group === void 0 ? void 0 : group.group_id,
                    groupId: group === null || group === void 0 ? void 0 : group.group_id,
                    group_name: (group === null || group === void 0 ? void 0 : group.name) || "",
                    groupName: (group === null || group === void 0 ? void 0 : group.name) || "",
                    name: selectedVariants[index].name,
                });
            }
        });
    }
    return selectedVariantList;
};
const getAddonPrice = (addon) => {
    const price = jsUtils.isEmpty(addon.price) ? 0 : addon.price;
    return components_FoodItem_helpers_index.possiblePrecision(price / 100);
};
const getTotalAddonPrice = (validAddons, selectedAddons) => {
    const selectedAddonsKeys = Object.keys(selectedAddons);
    if (selectedAddonsKeys.length === 0)
        return 0;
    let totalAddonPrice = 0;
    selectedAddonsKeys.forEach((groupIndex) => {
        const selectedChoices = Object.keys(selectedAddons[Number(groupIndex)]);
        if (!validAddons[Number(groupIndex)])
            return;
        const choices = getChoices(validAddons[Number(groupIndex)]);
        if (!jsUtils.isEmpty(choices)) {
            selectedChoices.forEach((choiceIndex) => {
                const choice = choices[Number(choiceIndex)];
                totalAddonPrice += +getAddonPrice(choice);
            });
        }
    });
    return totalAddonPrice;
};
const getTotalAddonVariantPrice = (validAddons, selectedAddons, selectedVariants) => {
    const selectedAddonsKeys = Object.keys(selectedAddons);
    const selectedVariantsKeys = Object.keys(selectedVariants);
    if (selectedAddonsKeys.length === 0 && selectedVariantsKeys.length === 0)
        return 0;
    let totalVariantPrice = 0;
    selectedVariantsKeys.forEach((key) => (totalVariantPrice += (selectedVariants[Number(key)].price || 0) / 100));
    return totalVariantPrice + getTotalAddonPrice(validAddons, selectedAddons);
};
const getOriginalPrice = (item) => {
    if (!jsUtils.isEmpty(item.default_variant_combination_final_price)) {
        return item.default_variant_combination_final_price / 100;
    }
    else if (!jsUtils.isEmpty(item.final_price)) {
        return item.final_price / 100;
    }
    else if (!jsUtils.isEmpty(item.price)) {
        return item.price / 100;
    }
    else if (!jsUtils.isEmpty(item.defaultPrice)) {
        return item.defaultPrice / 100;
    }
    return 0;
};
const getIsStrikethrough = (itemData) => {
    if (!itemData)
        return false;
    return Boolean((itemData === null || itemData === void 0 ? void 0 : itemData.itemPriceStrikeOff) || (itemData === null || itemData === void 0 ? void 0 : itemData.item_price_strike_off));
};
const getFinalPriceForVariantV1 = (itemData, totalAddonVariantPrice = 0) => {
    const isStrikeThrough = getIsStrikethrough(itemData);
    if (!isStrikeThrough)
        return null;
    const finalPrice = (itemData === null || itemData === void 0 ? void 0 : itemData.finalPrice) || 0 / 100;
    return !isNaN(finalPrice) ? finalPrice + totalAddonVariantPrice : 0;
};
const getV1Prices = (validAddons, selectedAddons, selectedVariants, itemData) => {
    const totalAddonVariantPrice = getTotalAddonVariantPrice(validAddons, selectedAddons, selectedVariants);
    const price = itemData
        ? getOriginalPrice(itemData) + totalAddonVariantPrice
        : totalAddonVariantPrice;
    const finalPrice = getFinalPriceForVariantV1(itemData, totalAddonVariantPrice);
    if (finalPrice) {
        return {
            price,
            finalPrice,
        };
    }
    return { price };
};
const getAddonInStock = (addon) => (addon === null || addon === void 0 ? void 0 : addon.inStock) === 1;
const getMinAddons = (addonGroup) => addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.minAddons;
const getMaxAddons = (addonGroup) => addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.maxAddons;
const getMaxFreeAddons = (addonGroup) => addonGroup.maxFreeAddons;
const getGroupId = (addonGroup) => addonGroup.group_id || addonGroup.groupId;
const getGroupName = (addonGroup) => (addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.group_name) || (addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.groupName);
const getAddonGroupV1Label = (selectedNumberOfAddons, groupName, minAddons) => {
    const displaySelected = Math.min(selectedNumberOfAddons, minAddons || 0);
    const getRenderGroupInfoText = () => {
        if (minAddons) {
            return `${displaySelected} out of ${minAddons} ${components_Customise_constants_index.TEXTS.REQUIRED}`;
        }
    };
    const renderGroupInfoText = minAddons ? getRenderGroupInfoText() : components_Customise_constants_index.TEXTS.OPTIONAL;
    return `${groupName}; ${renderGroupInfoText}`;
};
const getAccessibilityString = ({ name, vegType, price, inStock, }) => {
    return `${jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.VARIANT_OR_ADDON_NAME, name)} 
            ${vegType !== 1 ? components_Customise_constants_index.ACCESSIBILITY_TEXTS.NON_VEG_ITEM : components_Customise_constants_index.ACCESSIBILITY_TEXTS.EMPTY_STRING} 
            ${price !== undefined
        ? jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.PRICE, price)
        : components_Customise_constants_index.ACCESSIBILITY_TEXTS.EMPTY_STRING} 
            ${!inStock ? components_Customise_constants_index.ACCESSIBILITY_TEXTS.ITEM_NOT_AVAILABLE : components_Customise_constants_index.ACCESSIBILITY_TEXTS.EMPTY_STRING}`;
};
const getAddonItemV2Label = ({ name, addon, price, inStock, }) => {
    const addonItemV2Details = {
        name,
        vegType: addon.isVeg,
        price,
        inStock,
    };
    return getAccessibilityString(addonItemV2Details);
};
const getSelectedAddonsVariants = (itemData, validAddons, selectedAddons, selectedVariants) => {
    return new Promise((resolve, reject) => {
        const selectedAddonList = [];
        const selectedVariantList = [];
        const variantGroups = getVariants(itemData);
        variantGroups.forEach((group, index) => {
            var _a;
            if (!jsUtils.isEmpty(selectedVariants[index])) {
                selectedVariantList.push({
                    variation_id: selectedVariants[index].id,
                    variationId: selectedVariants[index].id,
                    group_id: group.group_id || group.groupId,
                    groupId: group.group_id || group.groupId,
                    name: selectedVariants[index].name,
                    price: (_a = selectedVariants[index].price) !== null && _a !== void 0 ? _a : 0,
                });
            }
        });
        if (!jsUtils.isEmpty(validAddons)) {
            validAddons.forEach((addonGroup, addonIndex) => {
                const groupName = getGroupName(addonGroup);
                const minAddons = getMinAddons(addonGroup) || 0;
                if (!jsUtils.isEmpty(selectedAddons[addonIndex])) {
                    if (minAddons > 0 &&
                        Object.keys(selectedAddons[addonIndex]).length < minAddons) {
                        reject({
                            message: jsUtils.format("You must select atleast {0} {1}", minAddons, groupName),
                        });
                        return false;
                    }
                    const choices = getChoices(addonGroup);
                    choices === null || choices === void 0 ? void 0 : choices.forEach((choice, choiceIndex) => {
                        if (!jsUtils.isEmpty(selectedAddons[addonIndex][choiceIndex])) {
                            selectedAddonList.push({
                                choice_id: getAddonId(choice),
                                choiceId: getAddonId(choice),
                                group_id: getGroupId(addonGroup),
                                groupId: getGroupId(addonGroup),
                                name: getAddonName(choice),
                                price: getAddonPrice(choice),
                            });
                        }
                    });
                }
                else if (minAddons > 0) {
                    reject({
                        message: jsUtils.format("You must select atleast {0} {1}", minAddons, groupName),
                    });
                    return false;
                }
            });
        }
        resolve({ selectedAddonList, selectedVariantList });
    });
};
const getAddButtonLabel = (getPriceValue, updatingExistingCustomization, price) => {
    const addButtonDetails = {
        price: price ? price : getPriceValue,
        footerText: updatingExistingCustomization ? components_Customise_constants_index.TEXTS.UPDATE_ITEM : components_Customise_constants_index.TEXTS.ADD_ITEM,
    };
    return `${jsUtils.format(components_Customise_constants_index.ACCESSIBILITY_TEXTS.TOTAL_IS, addButtonDetails.price)} 
            ${addButtonDetails.footerText === components_Customise_constants_index.TEXTS.ADD_ITEM
        ? components_Customise_constants_index.ACCESSIBILITY_TEXTS.DOUBLE_TAP_TO_ADD_TO_CART
        : components_Customise_constants_index.ACCESSIBILITY_TEXTS.DOUBLE_TAP_TO_UPDATE}`;
};
const getItemId = (item) => item === null || item === void 0 ? void 0 : item.id;
const replaceAllOccurence = (toFind, toReplace, str) => {
    return str === null || str === void 0 ? void 0 : str.replace(new RegExp(toFind, "g"), toReplace);
};
const getAddonGroup = (validAddons, groupIndex) => jsUtils.isEmpty(validAddons) ? {} : validAddons[groupIndex];
const checkMaxAddonsAddons = (addonGroup, choicesObj) => {
    return new Promise((resolve, reject) => {
        if (jsUtils.isEmpty(choicesObj)) {
            return resolve();
        }
        const maxAddons = getMaxAddons(addonGroup) || 0;
        const maxFreeAddons = getMaxFreeAddons(addonGroup);
        let selectedFreeAddons = 0;
        const choices = getChoices(addonGroup);
        const choiceIndexes = Object.keys(choicesObj);
        if (jsUtils.isEmpty(addonGroup) || jsUtils.isEmpty(choices)) {
            return reject(components_Customise_constants_index.ERRORS.OOPS);
        }
        const checkFree = maxFreeAddons !== components_Customise_constants_index.ALLOW_UNLIMITED_ADDONS;
        const checkAll = maxAddons !== components_Customise_constants_index.ALLOW_UNLIMITED_ADDONS;
        if (checkAll && choiceIndexes.length >= maxAddons) {
            return reject(jsUtils.format("You can select a maximum of {0} {1}.", maxAddons, getGroupName(addonGroup)));
        }
        if (checkFree) {
            const addonsNotMaxedOut = choiceIndexes.every((choiceIndex) => {
                const price = getAddonPrice(choices[Number(choiceIndex)]);
                if (Number(price) === 0) {
                    selectedFreeAddons++;
                    if (selectedFreeAddons === maxFreeAddons) {
                        reject(jsUtils.format("You can select a maximum of {0} free {1}.", maxFreeAddons, getGroupName(addonGroup)));
                        return false;
                    }
                }
                return true;
            });
            if (!addonsNotMaxedOut) {
                return;
            }
        }
        resolve();
    });
};
const convertMoneyToRupees = (finalPrice) => Number(finalPrice.units) + 0.01 * Number((finalPrice === null || finalPrice === void 0 ? void 0 : finalPrice.nanos) || 0);
const getFinalPriceFromPricingModel = (isStrikethrough, pricingModelVariant) => {
    var _a;
    if (!isStrikethrough)
        return null;
    if (!pricingModelVariant)
        return null;
    if ((_a = pricingModelVariant === null || pricingModelVariant === void 0 ? void 0 : pricingModelVariant.finalPrice) === null || _a === void 0 ? void 0 : _a.units)
        return convertMoneyToRupees(pricingModelVariant.finalPrice);
    if (typeof pricingModelVariant.finalPrice === "number")
        return pricingModelVariant.finalPrice / 100;
    return null;
};
const getV2Prices = (validAddons, selectedAddons, pricingModelHash, pricingModelKey, itemData) => {
    var _a;
    const totalAddonPrice = getTotalAddonPrice(validAddons, selectedAddons);
    const price = ((_a = pricingModelHash[pricingModelKey]) === null || _a === void 0 ? void 0 : _a.price)
        ? pricingModelHash[pricingModelKey].price / 100 + totalAddonPrice
        : totalAddonPrice;
    const isStrikethrough = getIsStrikethrough(itemData);
    const finalPrice = getFinalPriceFromPricingModel(isStrikethrough, pricingModelHash[pricingModelKey]);
    if (finalPrice) {
        return {
            finalPrice: finalPrice + totalAddonPrice,
            price,
        };
    }
    return { price };
};
const getV2VariantPrice = (pricingModelHash, pricingModelKey, variant, itemData) => {
    const selectedVariants = pricingModelKey.split("+");
    const lastGroup = selectedVariants[selectedVariants.length - 1].split("&");
    lastGroup[1] = variant.id;
    selectedVariants[selectedVariants.length - 1] = lastGroup.join("&");
    const newKey = selectedVariants.join("+");
    if (!pricingModelHash[newKey])
        return {};
    const price = pricingModelHash[newKey].price / 100;
    const isStrikethrough = getIsStrikethrough(itemData);
    const finalPrice = getFinalPriceFromPricingModel(isStrikethrough, pricingModelHash[newKey]);
    if (finalPrice) {
        return {
            finalPrice,
            price,
        };
    }
    return { price };
};
const getVariantItemV2Label = ({ variant, price, inStock, }) => {
    const variantItemV2Details = {
        name: variant.name,
        vegType: variant.isVeg,
        price,
        inStock,
    };
    return getAccessibilityString(variantItemV2Details);
};
const generateUUID = (menuItemId, selectedAddons = [], selectedVariants = []) => {
    const dataString = JSON.stringify({
        menu_item_id: menuItemId,
        addons: selectedAddons.map((a) => ({
            choice_id: a.choice_id,
            group_id: a.group_id,
        })),
        variants: selectedVariants.map((v) => ({
            variation_id: v.variation_id,
            group_id: v.group_id,
        })),
    });
    let hash = 0;
    for (let i = 0; i < dataString.length; i++) {
        const char = dataString.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
    }
    return Math.abs(hash).toString(16);
};

exports.CUSTOMIZE_VERSIONS = CUSTOMIZE_VERSIONS;
exports.PRICE_RANGE = PRICE_RANGE;
exports.checkMaxAddonsAddons = checkMaxAddonsAddons;
exports.generateUUID = generateUUID;
exports.getAccessibilityString = getAccessibilityString;
exports.getAddButtonLabel = getAddButtonLabel;
exports.getAddonGroup = getAddonGroup;
exports.getAddonGroupV1Label = getAddonGroupV1Label;
exports.getAddonId = getAddonId;
exports.getAddonInStock = getAddonInStock;
exports.getAddonItemV2Label = getAddonItemV2Label;
exports.getAddonName = getAddonName;
exports.getAddonPrice = getAddonPrice;
exports.getAddons = getAddons;
exports.getChoices = getChoices;
exports.getFinalPrice = getFinalPrice;
exports.getFinalPriceForVariantV1 = getFinalPriceForVariantV1;
exports.getFinalPriceFromPricingModel = getFinalPriceFromPricingModel;
exports.getGroupId = getGroupId;
exports.getGroupName = getGroupName;
exports.getIsStrikethrough = getIsStrikethrough;
exports.getItemId = getItemId;
exports.getMaxAddons = getMaxAddons;
exports.getMaxFreeAddons = getMaxFreeAddons;
exports.getMinAddons = getMinAddons;
exports.getName = getName;
exports.getOriginalPrice = getOriginalPrice;
exports.getPrice = getPrice;
exports.getPriceRange = getPriceRange;
exports.getPricingModels = getPricingModels;
exports.getSelectedAddons = getSelectedAddons;
exports.getSelectedAddonsVariants = getSelectedAddonsVariants;
exports.getSelectedVariants = getSelectedVariants;
exports.getTotalAddonPrice = getTotalAddonPrice;
exports.getTotalAddonVariantPrice = getTotalAddonVariantPrice;
exports.getV1Prices = getV1Prices;
exports.getV2Prices = getV2Prices;
exports.getV2VariantPrice = getV2VariantPrice;
exports.getVariantInStock = getVariantInStock;
exports.getVariantItemV2Label = getVariantItemV2Label;
exports.getVariants = getVariants;
exports.getVersion = getVersion;
exports.replaceAllOccurence = replaceAllOccurence;
//# sourceMappingURL=utils-CqsSjtb2.js.map
